<app-login-form
  (loginSuccessEvent)="onLoginSuccess()"
></app-login-form>
